import { createFileRoute } from '@tanstack/react-router';
import { NewEventPage } from '@/features/organizer/pages/EventFormPage';

export const Route = createFileRoute('/_authed/org/$organizationId/events/new')({
  staticData: { help: 'event-form' },
  component: NewEventPage,
});
